<template>
  <div class="dangyuan-wrapper" :style="{width:width*0.375+'px'}">
    <div class="dy-head">党员动态</div>
    <y-scroll :contentArr="partyMessage" :height="height * 0.79" :lineNum="1" :width="width*0.375" :startTime="9000">
      <div class="dy-item" slot="scroll" slot-scope="props">
        <img  class="dy-pic" :src="props.todo.headPic" :style="{width:height * 0.79}">
        <div class="dy-info" :style="{fontSize:no125?'15px':'12px'}">
          <div class="dy-name" style="color:#666e83">{{props.todo.name}}</div>
          <div :class="spanClass">{{props.todo.content}}</div>
          <!--<div class="dy-active">-->
            <!--<img  class="active-pic" src="./xi.png" >-->
            <!--<div class="active-info">学习习近平讲话动态...</div>-->
          <!--</div>-->
        </div>
      </div>
    </y-scroll>
  </div>
</template>

<script>
  import yScroll from '../../../components/yScroll'
  export default {
    components: {
      yScroll
    },
    props:{
      height:null,
      width:null,
      partyMessage:null
    },
    computed: {
      no125 () {
        return this.height/0.215>750 || this.width > 1550?true:false
      },
      spanClass () {
        return this.height>200?'duohang-slh1':'duohang-slh2'
      }
    },
    data () {
      return {
        num:[1]
      }
    }
  }
</script>

<style scoped>
  .dangyuan-wrapper{
    /*width:700px;*/
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 15px;
    color:#444;
  }
  .dy-head{
    /*height: 20px;*/
    /*line-height: 20px;*/
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .dy-item{
    width: 100%;
    height: 100%;
    padding:15px;
    display: flex;
  }
  .dy-pic{
    /*height: 130px;*/
    /*width: 130px;*/
    height: 100%;
    margin-right: 15px;
  }
  .dy-info{
    background: #f1f1f1;
    padding:10px;
    /*font-size: 15px;*/
    position: relative;
    flex:1
  }
  .dy-active{
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left:10px;
    /*height: 40px;*/
    height: 27.97%;
  }
  .active-pic{
    /*width: 60px;*/
    /*height:40px*/
    height: 100%;
  }
  .active-info{
    color:#666e83;
    vertical-align: top;
    font-size: 13px;
    padding-left:10px
  }
  .duohang-slh1{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
  }
  .duohang-slh2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
</style>

